import WaaveLandingPage from './WaaveLandingPage'

export default WaaveLandingPage
